/**
 * @prettier
 */

import React from 'react';
import styles from './styles.module.less';

const FlowOverlay = ({ children, overlayElement }) => {
  return (
    <div className={styles.box}>
      {children}
      {overlayElement && <div className={styles.overlayBox}>{overlayElement}</div>}
    </div>
  );
};

FlowOverlay.defaultProps = {
  overlayElement: null,
};

export default FlowOverlay;



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/FlowOverlay/FlowOverlay.jsx